import React, { useCallback, useMemo } from "react";
import styles from "./Style.module.css";
import constants from "../../../../../config/constants";
import DataTables from "../../../../../Datatables/Datatable.table";
import useProductQuizTable from "./ProductQuizTable.hook";
import StatusPill from "../../../../../components/Status/StatusPill.component";
import {  IconButton, Tooltip } from "@mui/material";
import {
  Info 
} from "@mui/icons-material";
import useRoles from "../../../../../hooks/RoleHook";
import Constants from "../../../../../config/constants";

const ProductQuizTable = ({}) => {
  const { canRead} = useRoles(Constants.MODULES.QUIZES_MODULE);
  const {
    handleSortOrderChange,
    handleRowSize,
    handlePageChange,
    isCalling,
    data,
    currentData,
    currentPage,
    isFetching,
    handleDetail
  } = useProductQuizTable({});

  const renderStatus = useCallback((status) => {
    if (status === "ACTIVE") {
      return <StatusPill status={"ACTIVE"} color={"active"} />;
    } else if (status === "INACTIVE") {
      return <StatusPill status={"INACTIVE"} color={"high"} />;
    } else if (status === "SCHEDULED") {
      return <StatusPill status={"SCHEDULED"} color={"medium"} />;
    }
  }, []);

  const tableStructure = useMemo(() => {
    return [
      {
        key: "topic",
        label: "Quiz Topic",
        sortable: false,
        render: (temp, all) => (
          <div>
            {all?.title}
          </div>
        ),
      },
      {
        key: "question",
        label: "Questions",
        sortable: false,
        render: (temp, all) => <div>{all?.total_questions}</div>,
      },
      {
        key: "reward",
        label: "Reward Points",
        sortable: false,
        render: (temp, all) => <div>{all?.total_reward_points}</div>,
      },

      {
        key: "timestamp",
        label: "Timestamp of pushing on app",
        sortable: false,
        render: (temp, all) => <div>{all?.startDateText}</div>,
      },
      {
        key: "status",
        label: "Status",
        sortable: false,
        render: (temp, all) => <div>{renderStatus(all?.status)}</div>,
      },
      ...(canRead
        ? [{
        key: "user_id",
        label: "Action",
        render: (temp, all) => (
          <div className={styles.actionButton}>
             <Tooltip
                    title={<>View Detail</>}
                    aria-label="info"
                    placement="right"
                    className={styles.infoTip}
                  >
            <IconButton
      disableRipple="false"
      onClick={() => {
        
        handleDetail(all);
      }}
    >
      <Info
        fontSize={"small"}
       
      />
    </IconButton></Tooltip>
            
          </div>
        ),
      },
    ]
    : []),
    ];
  }, [isCalling, renderStatus]);

  const tableData = useMemo(() => {
    const datatableFunctions = {
      onSortOrderChange: handleSortOrderChange,
      onPageChange: handlePageChange,
      onRowSizeChange: handleRowSize,
    };

    const datatable = {
      ...constants.DATATABLE_PROPERTIES,
      columns: tableStructure,
      data: currentData,
      count: data.length,
      page: currentPage - 1,
      rowsPerPage: 10,
      allRowSelected: false,
      showSelection: false,
    };

    return { datatableFunctions, datatable };
  }, [
    tableStructure,
    handleSortOrderChange,
    handlePageChange,
    handleRowSize,
    currentData,
    currentPage,
    data,
  ]); // allData,

  return (
    <div className={styles.mainContainer}>
      <DataTables {...tableData.datatable} {...tableData.datatableFunctions} />
    </div>
  );
};

export default ProductQuizTable;
